import { render, staticRenderFns } from "./materialconfirmation.vue?vue&type=template&id=6e161973&scoped=true"
import script from "./materialconfirmation.vue?vue&type=script&lang=js"
export * from "./materialconfirmation.vue?vue&type=script&lang=js"
import style0 from "./materialconfirmation.vue?vue&type=style&index=0&id=6e161973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e161973",
  null
  
)

export default component.exports